import type { ActivityItemProps } from "../types/layout.js";
import { IconTile } from "./IconTile.js";

export function ActivityItem({
  title,
  description,
  timestamp,
  dateLabel,
  icon,
  feedback,
  status,
  children,
}: ActivityItemProps) {
  return (
    <li className="flex gap-4 py-5 first:pt-0 last:pb-0">
      <IconTile>{icon}</IconTile>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-sm font-medium leading-relaxed">{title}</p>
            {description ? (
              <div className="mt-1 text-xs leading-relaxed text-muted-foreground">{description}</div>
            ) : null}
          </div>
          <time className="text-xs text-muted-foreground" dateTime={timestamp}>
            {dateLabel}
          </time>
        </div>
        {feedback ? (
          <blockquote className="mt-3 rounded-xl bg-warning p-3 text-sm text-warning-foreground">
            “{feedback}”
          </blockquote>
        ) : null}
        {status ? <div className="mt-3">{status}</div> : null}
        {children}
      </div>
    </li>
  );
}
